module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_co_cats_daily_necessities_2eaaf7b1d4937b48eae509b3ba750683.png";